import React, { useState } from "react";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { downloadSprintReport } from "./sprintReport";

/**
 * Auto-generated end-of-sprint QA report, listed with the sprint documents.
 * Shown to admins (high_potit) only, once the sprint is completed.
 */
const SprintReportLink = ({ sprint, admin, compact = false }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (!admin || sprint?.status !== "completed") return null;

  const run = async () => {
    setBusy(true);
    setError("");
    try {
      await downloadSprintReport(sprint);
    } catch (err) {
      setError(err?.message || "Could not build the report");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={compact ? "" : "py-2"}>
      <button
        type="button"
        onClick={run}
        disabled={busy}
        className="w-full flex items-center gap-2.5 text-left rounded-lg hover:bg-hover px-1 -mx-1 py-1 disabled:opacity-60"
        title="Points per developer from this sprint's Done tasks (QA rejections cost 1 point)"
      >
        {busy ? (
          <Loader2 className="w-4 h-4 text-accent animate-spin shrink-0" />
        ) : (
          <FileSpreadsheet className="w-4 h-4 text-ok shrink-0" />
        )}
        <span className="flex-1 min-w-0">
          <span className="block text-sm text-accent-ink hover:underline truncate">{sprint.name} — QA report.xlsx</span>
          {!compact && <span className="block text-[11.5px] text-faint">Generated from the sprint's Done tasks · High Potit only</span>}
        </span>
      </button>
      {error && <p className="text-xs text-danger mt-1">{error}</p>}
    </div>
  );
};

export default SprintReportLink;
